import { render } from "./ChannelPicker.vue?vue&type=template&id=836473d2"
import script from "./ChannelPicker.vue?vue&type=script&lang=js"
export * from "./ChannelPicker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__